import { createSelector } from 'reselect';

// Models
import { FeatureFlag } from 'app/shared/featureFlags/models';

// Selectors
import { selectHasReadAlertComponentButtonsPermissions } from 'app/modules/session/selectors';
import { selectFeatureFlags } from 'app/shared/featureFlags/selectors';

export const selectCanResolveTransactions = createSelector(
  selectHasReadAlertComponentButtonsPermissions,
  selectFeatureFlags,
  (hasReadAlertComponentButtonsPermissions, featureFlags) =>
    Boolean(
      hasReadAlertComponentButtonsPermissions &&
        featureFlags[FeatureFlag.ALERT_COMPONENT_BUTTONS],
    ),
);
